import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Preference } from '../../../types/Preference';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetAllPreferencesParams = {
  page?: number;
  per_page?: number;
  filters?: {
    keys: string[];
  };
};

type UseGetAllPreferencesProps = {
  params?: UseGetAllPreferencesParams;
  enabled?: boolean;
};

export const fetchAllPreferences = async ({ params }: { params?: UseGetAllPreferencesParams }) => {
  const response = await CustomAxios.get<Preference[]>('preferences', { params });
  return response.data;
};

export function useGetAllPreferences({ params, enabled = true }: UseGetAllPreferencesProps = {}) {
  const finalParams = useMemo<UseGetAllPreferencesParams>(() => ({ per_page: 0, ...params }), [params]);

  return useQuery({
    enabled,
    queryKey: [queryKeys.allPreferences, finalParams],
    queryFn: () => fetchAllPreferences({ params: finalParams }),
  });
}
